<template>
  <div class="w-full flex flex-col flex-1 safe-area-bottom">
    <delete-account
      v-if="subPage === 'delete-account'"
      @confirm="$emit('delete-account')"
      @cancel="cancel"
    />
    <logout-confirmation
      v-else-if="subPage === 'logout'"
      @confirm="$emit('logout')"
      @cancel="cancel"
    />
    <div v-else class="flex flex-1 flex-col items-center">
      <menu-item
        v-for="(item, index) in list"
        :item="item"
        :key="index"
        @click="clickHandler(item.event)"
      />
    </div>
  </div>
</template>

<script>
import deleteAccount from '@/assets/common/delete_account_icon.svg';
import logoutIcon from '@/assets/common/log-out.svg';
import deleteAccountSanne from '@/assets/sanne/icons/delete-account.svg';
import logoutIconSanne from '@/assets/sanne/icons/log-out.svg';
import DeleteAccount from '@/components/DefaultCloudzet/common/DeleteAccount.vue';
import LogoutConfirmation from '@/components/DefaultCloudzet/common/LogoutConfirmation.vue';
import MenuItem from './MenuItem.vue';

export default {
  components: {
    MenuItem,
    DeleteAccount,
    LogoutConfirmation,
  },
  props: {
    subPage: String,
  },
  data() {
    // data() runs before computed, so the brand is read from the store here
    const isSanne = this.$store.getters['app/isSanne'];
    return {
      list: [
        {
          img: isSanne ? deleteAccountSanne : deleteAccount,
          name: this.$t('homePage.delete_account'),
          target: '',
          pageName: 'delete-account',
          title: this.$t('homePage.delete_account'),
          event: 'delete-account',
        },
        {
          img: isSanne ? logoutIconSanne : logoutIcon,
          name: this.$t('homePage.logout'),
          target: '',
          pageName: 'logout',
          title: this.$t('homePage.logout'),
          event: 'logout',
        },
      ],
    };
  },
  methods: {
    clickHandler(event) {
      this.$emit('update:subPage', event);
    },
    cancel() {
      this.$emit('update:subPage', '');
    },
  },
};
</script>
